export default __webpack_public_path__ + "static/media/loader.ebed299c.gif";